/*
 * Copyright 2024, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import { Box } from "@mui/material";
import { useDasInventoryFilter } from "../../../pages/Configuration/DasInventory/hooks";
import GeneralFilter from "../../Shared/Filter/GeneralFilter";
import { resetDasInventoryFilters } from "../../../store/filters/dasInventory/reducer";
import { IRemoteEquipment } from "../../../store/api/devices/types";

interface IDasInventoryFilterProps {
  data: IRemoteEquipment[];
  children?: React.ReactNode;
}

export const DasInventoryFilter: React.FC<IDasInventoryFilterProps> = ({ data, children }) => {
  const { dispatch, filters, formControlSx } = useDasInventoryFilter({ data });

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
      <GeneralFilter
        dispatch={dispatch}
        filters={filters}
        formControlSx={formControlSx}
        resetFilters={resetDasInventoryFilters}
        searchTooltip="Search by name or serial number"
      />
      {children}
    </Box>
  );
};

export default DasInventoryFilter;
